import { gql } from '@apollo/client';

export const DELETE_GELADA_ORGANISATION_MUTATION = gql`
  mutation deleteGeladaOrganisation($organisationKey: String!) {
    organisation {
      deleteGeladaOrganisation: delete(key: $organisationKey)
    }
  }
`;
